
/**
 * Inserts text at the current cursor position in a textarea or replaces the selected text
 */
export const insertTextAtCursor = (
  textarea: HTMLTextAreaElement | null, 
  textToInsert: string, 
  fullContent: string,
  updateContent: (newContent: string) => void
) => {
  if (!textarea) {
    console.log("No textarea found, appending to end:", textToInsert);
    updateContent(fullContent + textToInsert);
    return;
  }
  
  console.log("Inserting text at cursor:", textToInsert);
  console.log("Cursor position:", textarea.selectionStart, textarea.selectionEnd);
  
  const startPos = textarea.selectionStart;
  const endPos = textarea.selectionEnd;
  
  const newContent = 
    fullContent.substring(0, startPos) + 
    textToInsert + 
    fullContent.substring(endPos);
  
  updateContent(newContent);
  
  // Set cursor position after the inserted text
  setTimeout(() => {
    if (textarea) {
      textarea.focus();
      const newCursorPos = startPos + textToInsert.length;
      textarea.setSelectionRange(newCursorPos, newCursorPos);
    }
  }, 10);
};
